import type { SnsError } from '@sumsub/websdk/types/types';

function formatErrorMessage(error: SnsError) {
  const message: string[] = [];

  if (error.code) message.push(error.code);
  if (error.reason) message.push(error.reason);

  return message.join(' - ');
}

export function enhanceSumsubErrorMessage(error: SnsError) {
  if (error.code === 'initialization-error') {
    return `${error.code} - ${error.error}`;
  }
  return formatErrorMessage(error);
}
